import React from 'react'
import { translate } from '../../assets/js/functions'
import { Link } from 'react-router-dom'

export default function InfoButton() {
    return (
        <Link to={'/info'} className="button button--icon button--info">{translate('Info')}</Link>
    )
}
